import React from 'react';
import classnames from 'classnames';
import { Box } from '@mui/material';
import { useLocalStorageState, useParticipantsContext, useScreenSize, useVideo } from 'hooks';
import { Participant } from '../Participant';

import styles from './GridView.module.scss';

export function GridView(): JSX.Element {
  const { gridViewParticipants } = useParticipantsContext();
  const { room } = useVideo();
  const localParticipant = room?.localParticipant;
  const { isDesktop, isMobile } = useScreenSize();
  const [isSelfViewCollapsed] = useLocalStorageState<boolean>('speakerViewSelfViewCollapsed', false);

  const shouldShowSelfViewSlot = Boolean(localParticipant && isSelfViewCollapsed);
  const participantsToRender = shouldShowSelfViewSlot
    ? gridViewParticipants
    : localParticipant
    ? [localParticipant, ...gridViewParticipants]
    : gridViewParticipants;

  const participantsLength = participantsToRender.length;

  return (
    <Box className={classnames(styles.container, { [styles.containerMobile]: isMobile })}>
      {shouldShowSelfViewSlot && localParticipant && (
        <Box className={styles.selfViewContainer}>
          <Participant participant={localParticipant as any} isLocalParticipant={true} withBorder showSelfViewToggle />
        </Box>
      )}

      <Box
        className={classnames(
          styles.participantContainer,
          {
            [styles.participantContainerDesktop]: isDesktop,
            [styles.participantContainerTablet]: !isDesktop && !isMobile,
            [styles.participantContainerMobile]: isMobile,
          },
          styles[`participantContainer-${participantsLength}`],
        )}
        overflow={isMobile ? 'scroll' : 'hidden'}
      >
        {participantsToRender.map((participant) => {
          const isLocalTile = participant === localParticipant;

          return (
            <Participant
              key={isLocalTile ? 'local-participant' : participant.sid}
              participant={participant}
              isLocalParticipant={isLocalTile}
              withBorder
              showSelfViewToggle={isLocalTile}
            />
          );
        })}
      </Box>
    </Box>
  );
}
